<template>
  <div class="home">
    <div class="middle">
      <el-carousel height="30vw" ref="carousel" @click.native="linkTo">
        <el-carousel-item v-for="(item, index) in lunboList" :key="index">
          <img :src="baseUrl + item.path" class="lunbo-img" :onerror="default_lunbo_img" />
        </el-carousel-item>
      </el-carousel>
      <el-tabs v-show="showTab">
        <el-tab-pane v-if="hasResource">
          <span slot="label">
            <img class="icon" src="~@/common/img/icon_ranking_list.png" alt="" />
            <!-- <i class="el-icon-thumb"></i> -->
            热门资源</span>
          <el-table :data="clickPartList" style="width: 100%" :show-header="false" @row-click="clickUrl">
            <el-table-column type="index" width="40" align="center"></el-table-column>
            <el-table-column prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column prop="click" width="80">
              <template slot-scope="scope">
                <i class="el-icon-thumb"></i>
                <span style="margin-left: 5px">{{ scope.row.click }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="消息中心">
          <span slot="label">
            <!-- <i class="el-icon-bell"></i> -->
            <img class="icon" src="~@/common/img/icon_notice.png" alt="" />
            通知公告
          </span>
          <el-table :data="noticePartList" style="width: 100%" :show-header="false" @row-click="clickNoticeUrl">
            <el-table-column prop="title" show-overflow-tooltip></el-table-column>
            <el-table-column prop="send_date" width="120">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 5px">{{
                  scope.row.send_date.slice(0, -9)
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="width:100%;" v-for="(nav,i) in navList" :key="i">
      <div class="top" v-if="nav.path.indexOf('/micro/live?live_type=1') > -1">
        <div class="live-box">
          <div class="title">
            <img src="~@/common/img/icon_live.png" alt="" />
            {{ nav.name }}
            <el-link href="#/micro/live" :underline="false">
              更多
              <i class="el-icon-caret-right"></i>
            </el-link>
          </div>
          <div class="live-list">
            <template v-if="liveList.length !== 0">
              <div class="video" v-for="(item, index) in livePartList" :key="index">
                <div class="click-box" @click="toLiveUrl(item)">
                  <div class="video-img" :title="item.name">
                    <img class="poster" :src="baseUrl + item.thumbnail_path" :onerror="default_live_img" />
                    <span class="video-tag" v-if="item.state == 1" style="background: #559af9">即将开始</span>
                    <span class="video-tag" v-else-if="item.state == 2" style="background: #fe2f37">正在直播</span>
                    <span class="video-tag" v-else-if="item.state == 3" style="background: #e7e7e7; color: #a9a9a9">已经结束</span>
                    <div class="video-play-bg">
                      <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                    </div>
                    <div class="viewer">{{ item.people_counts }} 人正在观看</div>
                  </div>
                  <div class="video-name" :title="item.name">{{ item.name }}</div>
                </div>
                <div class="video-detail">
                  <div>{{ item.teacher_name }} | {{ item.subject_name }}</div>
                  <div>{{ item.reserved_time || item.start_time }}</div>
                </div>
              </div>
            </template>
            <div class="empty" v-else>
              <img src="~@/common/img/no_data.png" alt="暂无数据" />
              <span>暂无数据</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="nav.path.indexOf('micro/resource') > -1">
        <div class="resource-box">
          <div class="title">
            <img src="~@/common/img/icon_resource.png" alt="" />
            {{ nav.name }}
            <el-link href="#/micro/resource" :underline="false">
              更多
              <i class="el-icon-caret-right"></i>
            </el-link>
          </div>
          <div class="out-box">
            <div style="display: flex">
              <template v-if="resourceList.length !== 0">
                <div class="left-box">
                  <div class="first-resource" v-for="(item, index) in resourceFirst" :key="index">
                    <div class="click-box" @click="toShareUrl(item.id)">
                      <div class="video-img" :title="item.name">
                        <img class="poster" :src="baseUrl + item.thumbnail_path" :onerror="default_thumbnail_img" />
                        <div class="video-play-bg">
                          <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                        </div>
                      </div>
                      <div class="video-name" :title="item.name">
                        {{ item.name }}
                      </div>
                      <div class="video-detail">
                        <div class="video-detail-owner">
                          {{ item.owner_name }} | {{ item.subject }}
                        </div>
                        <div class="btn-box">
                          <el-link icon="el-icon-video-play" :underline="false">播放量 {{ item.click }}</el-link>
                          <el-link class="mar-left" icon="el-icon-download" :underline="false">下载量 {{ item.download }}</el-link>
                          <el-link class="mar-left" icon="el-icon-star-off" :underline="false">收藏量 {{ item.favorite }}</el-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right-box">
                  <div class="other-resource">
                    <div class="video" v-for="(item, index) in resourcePartList" :key="index">
                      <div class="click-box" @click="toShareUrl(item.id)">
                        <div class="video-img" :title="item.name">
                          <img class="poster" :src="baseUrl + item.thumbnail_path" :onerror="default_thumbnail_img" />
                          <div class="video-play-bg">
                            <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                            <div class="button-box">
                              <el-link icon="el-icon-video-play" :underline="false">{{ item.click }}</el-link>
                              <el-link class="mar-left" icon="el-icon-download" :underline="false">{{ item.download }}</el-link>
                              <el-link class="mar-left" icon="el-icon-star-off" :underline="false">{{ item.favorite }}</el-link>
                            </div>
                          </div>
                        </div>
                        <div class="video-name" :title="item.name">
                          {{ item.name }}
                        </div>
                      </div>
                      <div class="video-detail">
                        <div class="video-detail-owner">
                          {{ item.owner_name }} | {{ item.subject }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="empty" v-else>
                <img src="~@/common/img/no_data.png" alt="暂无数据" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top" v-if="nav.path.indexOf('micro/deliveryclass') > -1">
        <div class="live-box">
          <div class="title">
            <img src="~@/common/img/icon_delivery_class.png" alt="" />
            {{ nav.name }}
            <el-link href="#/micro/deliveryclass" :underline="false">
              更多
              <i class="el-icon-caret-right"></i>
            </el-link>
          </div>
          <div class="delivery-class-list">
            <template v-if="deliveryClassList.length !== 0">
              <div class="video" v-for="(item, index) in deliveryClassList" :key="index">
                <div class="click-box" @click="toDeliveryClassUrl(item.id)">
                  <div class="video-img" :title="item.main_school_name + ' · ' + item.main_class_name">
                    <img class="poster" :src="deliveryclassVideoImg" :onerror="default_thumbnail_img" />
                    <span class="video-tag" v-if="item.state == 0" style="background: #559af9">即将开始</span>
                    <span class="video-tag" v-else-if="item.state == 1" style="background: #fe2f37">正在直播</span>
                    <span class="video-tag" v-else-if="item.state == 2" style="background: #e7e7e7; color: #a9a9a9">已经结束</span>
                    <div class="video-play-bg">
                      <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                    </div>
                  </div>
                  <div class="video-name" :title="item.main_school_name + ' · ' + item.main_class_name">
                    {{ item.main_school_name }} · {{ item.main_class_name }}
                  </div>
                </div>
                <div class="video-detail">
                  <div>
                    {{ item.main_teacher_name }} | {{ item.subject_name }}
                  </div>
                  <div>{{ item.start_time || item.reserved_time }}</div>
                </div>
              </div>
            </template>
            <div class="empty" v-else>
              <img src="~@/common/img/no_data.png" alt="暂无数据" />
              <span>暂无数据</span>
            </div>
          </div>
        </div>
      </div>
      <div class="top2" v-if="nav.path.indexOf('micro/famous_teacher') > -1">
        <div class="famous-teacher">
          <div class="teacher-box">
            <div class="title">
              <img src="~@/common/img/icon_famous_school_lesson.png" alt="" />
              {{ nav.name }}
              <el-link href="#/micro/famous_teacher/teacher_list" :underline="false">
                更多
                <i class="el-icon-caret-right"></i>
              </el-link>
            </div>
            <div class="teacher-list">
              <template v-if="famousTeacherList.length !== 0">
                <div class="teacher" v-for="(item,i) in famousTeacherList" :key="i">
                  <div class="click-box" @click="toTeacherHome(item)">
                    <div class="video-img" :title="item.user_name">
                      <img class="poster" :src="item.icon_url" :onerror="default_thumbnail_img" />
                    </div>
                    <div class="teacher-name" :title="item.user_name">
                      {{ item.user_name }}
                    </div>
                  </div>
                </div>
              </template>
              <div class="empty" v-else>
                <img src="~@/common/img/no_data.png" alt="暂无数据" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom" v-if="nav.path.indexOf('micro/mooc') > -1">
        <div class="resource-box">
          <div class="title">
            <img src="~@/common/img/icon_mooc.png" alt="" />
            {{ nav.name }}
            <el-link href="#/micro/mooc" :underline="false">
              更多
              <i class="el-icon-caret-right"></i>
            </el-link>
          </div>
          <div class="out-box">
            <div style="display: flex">
              <template v-if="moocFirst.length !== 0">
                <div class="left-box">
                  <div class="first-resource" v-for="(item, index) in moocFirst" :key="index">
                    <div class="click-box" @click="toMoocUrl(item.id)">
                      <div class="video-img" :title="item.name">
                        <img class="poster" :src="baseUrl + item.thumbnail_path" :onerror="default_thumbnail_img" />
                        <div class="video-play-bg">
                          <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                        </div>
                      </div>
                      <div class="video-name" :title="item.name">
                        {{ item.name }}
                      </div>
                      <div class="video-detail">
                        <div class="video-detail-owner">
                          {{ item.user_name }} | {{ item.subject }}
                        </div>
                        <div class="btn-box">
                          <el-link icon="el-icon-video-play" :underline="false">播放量 {{ item.click }}</el-link>
                          <el-link class="mar-left" icon="el-icon-chat-dot-round" :underline="false">评论量 {{ item.comment }}</el-link>
                          <el-link class="mar-left" icon="el-icon-star-off" :underline="false">收藏量 {{ item.collect }}</el-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right-box">
                  <div class="other-resource">
                    <div class="video" v-for="(item, index) in moocPartList" :key="index">
                      <div class="click-box" @click="toMoocUrl(item.id)">
                        <div class="video-img" :title="item.name">
                          <img class="poster" :src="baseUrl + item.thumbnail_path" :onerror="default_thumbnail_img" />
                          <div class="video-play-bg">
                            <img src="~@/common/img/play_button.png" alt="点击播放" height="40px" width="40px" />
                            <div class="button-box">
                              <el-link icon="el-icon-video-play" :underline="false">{{ item.click }}</el-link>
                              <el-link class="mar-left" icon="el-icon-chat-dot-round" :underline="false">{{ item.comment }}</el-link>
                              <el-link class="mar-left" icon="el-icon-star-off" :underline="false">{{ item.collect }}</el-link>
                            </div>
                          </div>
                        </div>
                        <div class="video-name" :title="item.name">
                          {{ item.name }}
                        </div>
                      </div>
                      <div class="video-detail">
                        <div class="video-detail-owner">
                          {{ item.user_name }} | {{ item.subject }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="empty" v-else>
                <img src="~@/common/img/no_data.png" alt="暂无数据" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top2">
      <div class="famous-teacher">
        <div class="teacher-box">
          <div class="title">
            <img src="~@/common/img/icon_famous_school_lesson.png" alt="" />
            公开课
          </div>
          <div class="teacher-list" style="flex-wrap:wrap;">
            <template v-if="linkList.length !== 0">
              <div class="teacher" v-for="(item,i) in linkList" :key="i">
                <div class="click-box" @click="toOtherHome(item.link_url)">
                  <div class="video-img" :title="item.name">
                    <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                      <img :src="item.img_url" class="link-poster" />
                    </div>
                  </div>
                  <div class="teacher-name" :title="item.name">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </template>
            <div class="empty" v-else>
              <img src="~@/common/img/no_data.png" alt="暂无数据" />
              <span>暂无数据</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseApi from "@/api/base";
import liveApi from "@/api/live";
import resourceApi from "@/api/resource";
import deliveryClassApi from "@/api/delivery_class";
import famousTeacherApi from "@/api/famous_teacher";
import moocApi from "@/api/mooc";
import operateApi from "@/api/operate";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "SchoolHome",
  data() {
    return {
      schoolId: 0,
      showHeight: 0,
      firstNoticeId: 0,
      sharePath: "",
      livePath: "",
      page: 1,
      pageSize: 7,
      lunboList: [],
      liveList: [],
      livePartList: [],
      resourceList: [],
      resourceFirst: [],
      resourcePartList: [],
      deliveryClassList: [],
      deliveryclassVideoImg: require("@/common/img/video-img.png"),
      famousTeacherList: [],
      clickList: [],
      clickPartList: [],
      noticeList: [],
      noticePartList: [],
      moocFirst: [],
      moocPartList: [],
      baseUrl: window.staticsHost,
      defaultResource: {
        id: "default",
        name: "共享资源",
        owner_name: "姓名",
        subject: "科目",
        thumbnail_path: "",
        click: 0,
        download: 0,
        favorite: 0,
        score: 0,
      },
      default_thumbnail_img: 'this.src="' + require("@/common/img/default.png") + '"',
      default_lunbo_img: 'this.src="' + require("@/common/img/default3.png") + '"',
      default_live_img: 'this.src="' + require("@/common/img/video_img.png") + '"',
      navList: [],
      hasResource: false,
      linkList: [
        {
          name: "国家中小学智慧教育平台",
          img_url: require("@/common/img/new_open_class/1.png"),
          link_url: "https://basic.smartedu.cn/"
        },
        {
          name: "国家高等教育智慧教育平台",
          img_url: require("@/common/img/new_open_class/2.png"),
          link_url: "https://higher.smartedu.cn/"
        },
        {
          name: "国家职业教育智慧教育平台",
          img_url: require("@/common/img/new_open_class/3.png"),
          link_url: "https://vocational.smartedu.cn/"
        },
        {
          name: "爱课程",
          img_url: require("@/common/img/new_open_class/4.png"),
          link_url: "https://www.icourse163.org/"
        },
        {
          name: "学堂在线",
          img_url: require("@/common/img/new_open_class/5.png"),
          link_url: "https://next.xuetangx.com/"
        },
        {
          name: "学银在线",
          img_url: require("@/common/img/new_open_class/6.png"),
          link_url: "https://www.xueyinonline.com/"
        },
        {
          name: "超星尔雅",
          img_url: require("@/common/img/new_open_class/7.png"),
          link_url: "http://mooc1.chaoxing.com/"
        },
        {
          name: "中国高校外语慕课平台",
          img_url: require("@/common/img/new_open_class/8.png"),
          link_url: "https://moocs.unipus.cn/"
        },
        {
          name: "人民公开课",
          img_url: require("@/common/img/new_open_class/9.png"),
          link_url: "https://moocpeople.cn/"
        }
      ],
      showTab: Boolean(getStorage('user')) && getStorage('user') != ' '
    };
  },
  created() {
    this.getSchoolId();
    this.getNavList();
  },
  mounted() {
    this.getLunboList();
    this.getLivePage();
    this.getSharePage();
    this.getDeliveryClassList();
    // this.getfamousTeacherList();
    this.getPageByClick();
    this.getNoticePage();
    this.getMoocPage();
  },
  methods: {
    // 轮播图跳转
    linkTo() {
      let activeIndex = this.$refs.carousel.activeIndex;
      if (this.lunboList[activeIndex] == undefined) {
        this.$router.push("/");
      } else {
        window.open(this.lunboList[activeIndex].link_url, "_self");
      }
    },
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      let schoolInfo = getStorage("school");
      if (schoolInfo) {
        this.schoolId = schoolInfo.org_id;
        return;
      }
    },
    // 获取轮播图列表
    getLunboList() {
      const data = {
        area_id: this.schoolId,
        area_type: 2,
      };
      baseApi.getLunboList(data).then((response) => {
        if (response.data.status == 0) {
          this.lunboList = [];
          if (response.data.data) {
            this.lunboList = response.data.data;
          } else {
            this.lunboList.push(this.default_lunbo_img);
          }
        }
      });
    },
    // 【前台】获取直播列表（分页）
    getLivePage() {
      let params = {
        page: 1,
        page_size: 5,
        school_id: this.schoolId,
        is_share: 1
      };
      liveApi.getLivePage(params).then((response) => {
        if (response.data.status == 0) {
          this.liveList = response.data.data.list ? response.data.data.list : [];
          //只取前五条显示
          for (let i = 0; i < 5; i++) {
            // 拼接时间
            if (i <= this.liveList.length - 1) {
              if (this.liveList[i].start_time != "") {
                this.liveList[i].start_time =
                  this.liveList[i].start_time.split(" ")[0].split("-")[1] +
                  "-" +
                  this.liveList[i].start_time.split(" ")[0].split("-")[2] +
                  " " +
                  this.liveList[i].start_time.split(" ")[1].split(":")[0] +
                  ":" +
                  this.liveList[i].start_time.split(" ")[1].split(":")[1];
              }
              this.livePartList.push(this.liveList[i]);
            }
          }
        }
      });
    },
    // 获取专递课堂列表
    getDeliveryClassList() {
      const data = {
        page: 1,
        page_size: 5,
        id: this.schoolId,
        type: 2,
      };
      deliveryClassApi.getDeliveryClassList(data).then((response) => {
        if (response.data.status == 0) {
          this.deliveryClassList = response.data.data.list ? response.data.data.list : [];
        }
      });
    },
    // 获取名师列表
    getfamousTeacherList() {
      const data = {
        school_id: this.schoolId,//多余，容错
        area_id: this.schoolId,
        area_type: 2,
        page: 1,
        page_size: 5,
        is_famous: 2,
      };
      famousTeacherApi.getFamousTeacherList(data).then((response) => {
        if (response.data.status === 0) {
          let list = response.data.data.list ? response.data.data.list : [];
          for (let i = 0; i < list.length; i++) {
            list[i].icon_url = window.staticsHost + list[i].image_path;
          }
          this.famousTeacherList = list;
        }
      });
    },
    // 【前台】获取共享资源列表（分页）
    getSharePage() {
      let params = {
        school_id: this.schoolId,
        page: 1,
        page_size: 7,
      };
      resourceApi.getSharePage(params).then((response) => {
        if (response.data.status == 0) {
          this.resourceList = response.data.data.list ? response.data.data.list : [];
          if (this.resourceList.length > 0) {
            //取第一条显示
            this.resourceFirst.push(response.data.data.list[0]);
          }
          // else {
          //   let defaultResource = JSON.parse(
          //     JSON.stringify(this.defaultResource)
          //   );
          //   defaultResource.id = "default0";
          //   this.resourceFirst.push(defaultResource);
          // }

          //取前2~7条显示
          for (let i = 1; i < 7; i++) {
            if (i <= this.resourceList.length - 1) {
              this.resourcePartList.push(response.data.data.list[i]);
            }
            // else {
            //   let defaultResource = JSON.parse(JSON.stringify(this.defaultResource));
            //   defaultResource.id = "default" + i;
            //   this.resourcePartList.push(defaultResource);
            // }
          }
        }
      });
    },
    //【前台】获取在线课程列表（分页）
    getMoocPage() {
      let params = {
        area_id: this.schoolId,
        area_type: 2,
        keyword: "",
        page: 1,
        page_size: 7,
        sort: 0,
        subject_id: 0,
        category_id: 0,
      };
      moocApi.getMoocPage(params).then((response) => {
        if (response.data.status == 0) {
          let data = response.data.data.list ? response.data.data.list : [];
          if (data.length > 0) {
            this.moocFirst.push(data[0]);
            if (data.length > 1) {
              for (let i = 1; i < data.length; i++) {
                this.moocPartList.push(data[i]);
              }
            }
          }
        }
      });
    },
    // 跳转到直播详情页面
    toLiveUrl(item) {
      operateApi.getLiveFree({ school_id: getStorage("school").org_id }).then((res) => {
        if (res.data.status == 0) {
          if (!res.data.data) {
            this.$message({
              type: "warning",
              message: "直播流量已用尽，请联系管理员续费",
              docuration: 5000
            });
          } else if (item.live_type == 1) {
            this.$router.push({
              path: "micro/live/classroom_live_detail",
              name: "classroom_live_detail",
              query: {
                id: item.id,
              },
            });
          } else if (item.live_type == 3) {
            this.$router.push({
              path: "micro/live/live_detail_broadcast",
              name: "live_detail_broadcast",
              query: {
                id: item.id
              },
            });
          } else if (item.live_type == 4) {
            this.$router.push({
              path: "micro/live/drag_live_detail",
              name: "drag_live_detail",
              query: {
                id: item.id
              },
            });
          } else {
            this.$router.push({
              path: "micro/live/live_detail",
              name: "live_detail",
              query: {
                id: item.id,
              },
            });
          }
          this.$bus.$emit("openChildApps");
        } else {
          this.$message({
            type: "error",
            message: res.data.info.detail
          });
        }
      });
    },
    // 获取id并跳转到专递课堂详情页面
    toDeliveryClassUrl(id) {
      if (typeof id == "number") {
        this.$router.push({
          path: "micro/deliveryclass/videodetail",
          query: {
            id,
          },
        });
        this.$bus.$emit("openChildApps");
      }
    },
    // 跳转对应名师
    toTeacherHome(item) {
      this.$router.push({
        path: "/micro/famous_teacher",
        query: {
          teacherId: item.user_id,
        },
      });
    },
    // 跳转对应平台
    toOtherHome(url) {
      window.open(url, "_blank");
    },
    // 获取id并跳转到共享资源详情页面
    toShareUrl(id) {
      operateApi.getVideoFree({ school_id: getStorage("school").org_id }).then((res) => {
        if (res.data.status == 0) {
          if (!res.data.data) {
            this.$message({
              type: "warning",
              message: "点播流量已用尽，请联系管理员续费",
              docuration: 5000
            });
          } else if (typeof id == "number") {
            // this.addResourceClick(id);
            this.$router.push({
              path: "micro/resource/resource_detail",
              query: {
                id: id,
              },
            });
            this.$bus.$emit("openChildApps");
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.info.detail
          });
        }
      });
    },
    // 获取id并跳转到通知公告详情页面
    toNoticeUrl(noticeId) {
      if (getStorage("user")) {
        if (noticeId != 0) {
          this.$router.push({
            path: "notice",
            query: {
              id: noticeId,
            },
          });
        } else {
          this.$router.push({
            path: "notice",
            query: {
              id: this.firstNoticeId,
            },
          });
        }
        this.$bus.$emit("openChildApps");
      } else {
        this.$message({
          type: "info",
          message: "需要登录才能查看公告信息！",
        });
        // this.$router.push({
        //   path: "/login",
        // });
      }
    },
    // 获取id并跳转到慕课详情页面
    toMoocUrl(id) {
      operateApi.getVideoFree({ school_id: getStorage("school").org_id }).then((res) => {
        if (res.data.status == 0) {
          if (!res.data.data) {
            this.$message({
              type: "warning",
              message: "点播流量已用尽，请联系管理员续费",
              docuration: 5000
            });
          } else if (typeof id == "number") {
            moocApi.addClick(id).then((response) => {
              if (response.status == 0) {
                // console.log(response);
              }
            });
            moocApi.addHistory(id).then((response) => {
              if (response.status == 0) {
                // console.log(response);
              }
            });
            this.$router.push({
              path: "micro/mooc/mooc_detail",
              query: {
                moocId: id,
              },
            });
            this.$bus.$emit("openChildApps");
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.info.detail
          });
        }
      });
    },
    //【前台】获取共享资源列表（按点击量获取）（分页）
    getPageByClick() {
      let params = {
        school_id: this.schoolId,
        page: 1,
        page_size: 10,
      };
      resourceApi.getPageByClick(params).then((response) => {
        if (response.data.status == 0) {
          this.clickList = response.data.data.list ? response.data.data.list : [];
          if (this.clickList.length > 0) {
            switch (true) {
              case this.showHeight <= 393:
                for (let i = 0; i < 5; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 441:
                for (let i = 0; i < 6; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 489:
                for (let i = 0; i < 7; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 537:
                for (let i = 0; i < 8; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 585:
                for (let i = 0; i < 9; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
                break;
              default:
                for (let i = 0; i < 10; i++) {
                  this.clickPartList.push(response.data.data.list[i]);
                  if (i == this.clickList.length - 1) {
                    break;
                  }
                }
            }
          }
        }
      });
    },
    // 获取通知公告列表（分页）
    getNoticePage() {
      let params = {
        page: 1,
        page_size: 10,
        // school_id: this.schoolId
        area_id: this.schoolId,
        area_type: 2,
      };
      baseApi.getNoticePage(params).then((response) => {
        if (response.data.status == 0) {
          this.noticeList = response.data.data.list ? response.data.data.list : [];
          if (this.noticeList && this.noticeList.length > 0) {
            this.firstNoticeId = this.noticeList[0].id;
            switch (true) {
              case this.showHeight <= 393:
                for (let i = 0; i < 5; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 441:
                for (let i = 0; i < 6; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 489:
                for (let i = 0; i < 7; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 537:
                for (let i = 0; i < 8; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
                break;
              case this.showHeight <= 585:
                for (let i = 0; i < 9; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
                break;
              default:
                for (let i = 0; i < 10; i++) {
                  this.noticePartList.push(response.data.data.list[i]);
                  if (i == this.noticeList.length - 1) {
                    break;
                  }
                }
            }
          }
        }
      });
    },
    // 点击跳转
    clickUrl(row) {
      this.toShareUrl(row.id);
    },
    // 点击跳转
    clickNoticeUrl(row) {
      this.toNoticeUrl(row.id);
    },
    // 增加资源点击量
    addResourceClick(id) {
      resourceApi.addResourceClick(id).then((response) => {
        if (response.status == 0) {
          // console.log("新增一次资源点击");
        }
      });
    },
    // 获取下拉菜单数据
    getNavList() {
      const data = this.orgType === 1 ? { area_id: this.schoolId } : { school_id: this.schoolId };
      baseApi.getNavigationList(data).then((response) => {
        if (response.data.status === 0) {
          let list = response.data.data.list ? response.data.data.list : [];
          for (let i = 0; i < list.length; i++) {
            // let loginpath = /\/login\/.*?\//.exec(list[i].path);
            if (list[i].path != "/login") {
              this.navList.push(list[i]);
            }
            if (list[i].path.indexOf('resource') > -1) {
              this.hasResource = true;
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">
body {
  overflow-x: hidden;
}

.lunbo-img {
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.mar-left {
  margin-left: 10px;
}

.middle {
  height: 30vw;
  min-height: 345px;
  width: 100%;
  background: url('~@/common/img/banner.png');
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;

  /deep/ .el-carousel {
    min-height: 345px !important;
    width: 100vw;

    .el-carousel__container {
      min-height: 345px !important;
    }
  }

  /deep/ .el-tabs {
    width: 380px;
    min-width: 250px;
    height: 23vw;
    position: absolute;
    top: 90px;
    right: 10vw;
    background: rgba(0, 36, 72, 0.7);
    border: none;
    border-radius: 10px;
    z-index: 99;
    overflow-y: auto;

    .el-tabs__header {
      .el-tabs__nav-wrap::after {
        background: rgba(255, 255, 255, 0.4);
      }

      .el-tabs__nav {
        width: 100%;

        .el-tabs__active-bar {
          background: rgba(64, 158, 255, 0.6);
        }

        .el-tabs__item {
          width: 50%;
          color: #ececec;
          padding: 0px !important;
          transition: all 0.5s;

          &:hover {
            color: #fff;
          }

          span {
            display: flex;
            justify-content: center;
            align-items: center;

            .icon {
              width: 14px;
              height: 14px;
              margin-right: 10px;
            }
          }
        }

        .is-active {
          color: #fff;
        }
      }
    }

    .el-tabs__content {
      padding: 2px 10px;

      .el-table {
        color: #f2f2f2;

        .el-table__body tr:hover>td {
          background: transparent !important;
          color: #ececec;
          font-size: 15px !important;
        }

        .el-table__empty-text {
          color: #ececec;
        }

        td {
          transition: all 0.1s linear;
          font-size: 14px;
          padding: 0.3vw 0px;
        }
      }
    }
  }

  .ranking-list {
    width: 30%;
    height: 100%;
    padding-top: 3vh;
    margin-right: 10%;
    box-sizing: border-box;
  }

  @media screen and (max-width: 900px) {
    .notice {
      display: none;
    }

    .ranking-list {
      width: 70%;
    }
  }

  .notice {
    width: 40%;
    height: 100%;
    padding-top: 3vh;
    box-sizing: border-box;
  }
}

.click-box {
  cursor: pointer;

  .video-img {
    position: relative;
    overflow: hidden;
    transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;

    .poster {
      height: 100%;
      width: 100%;
      transition: all 0.6s;
    }

    .video-tag {
      font-size: 14px;
    }

    .video-play-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      opacity: 0;
      visibility: hidden;
    }
  }
}

.click-box:hover {
  .video-img .poster {
    transform: scale(1.1);
  }

  /deep/ .video-img .video-play-bg {
    visibility: visible !important;
    opacity: 1 !important;
  }
}

.title {
  width: 100%;
  height: 42px;
  line-height: 42px;
  font-size: 30px;
  text-align: left;
  display: flex;
  align-items: center;
  // border-left: 4px solid #569AF8;
  // padding-left: 20px;
  font-weight: 500;

  img {
    width: 1em;
    height: 1em;
    margin-right: 10px;
  }

  .el-link {
    height: 27px;
    width: 55px;
    line-height: 27px;
    border-radius: 27px;
    text-align: center;
    margin-left: 40px;
    border: 1px solid #E4E7ED;
    padding-left: 5px;
  }

  .el-link:hover {
    border-color: #569AF8;
    color: #569AF8;
  }
}

.top {
  width: 100%;
  height: calc(14.6vw + 82px);
  min-height: 292px;
  margin: 6.5vh 0;

  .live-box {
    width: 80%;
    height: 100%;
    margin: auto;

    .live-list {
      width: 100%;
      height: 14.6vw;
      min-height: 210px;
      margin-top: 40px;
      display: flex;
      justify-content: flex-start;
      overflow-x: auto;

      .video {
        width: 14.4vw;
        height: 100%;
        min-width: 192px;
        display: inline-block;
        border-radius: 3px;
        overflow: hidden;

        a {
          text-decoration: none;
          color: black;
        }

        .video-img {
          width: 100%;
          height: 8.1vw;
          min-height: 108px;

          span {
            color: white;
            position: absolute;
            right: 0;
            padding: 0.2rem 0.5rem;
            border-radius: 0 3px;
          }

          .video-tag {
            font-size: 14px;
          }

          .viewer {
            width: 100%;
            height: 20%;
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            text-align: left;
            display: flex;
            font-size: 14px;
            align-items: center;
            color: white;
            padding-left: 0.5rem;
            box-sizing: border-box;
          }
        }

        .video-name {
          width: 100%;
          height: 2.5vw;
          min-height: 30px;
          white-space: nowrap;
          padding-left: 2px;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-weight: 500;
          text-align: left;
          display: flex;
          align-items: center;
        }

        .video-detail {
          height: 4vw;
          min-height: 40px;
          font-size: 14px;
          color: #909399;
          position: relative;

          div {
            text-align: left;
            height: 2vw;
            min-height: 20px;
          }

          div:nth-of-type(2) {
            font-size: 12px;
          }
        }

        @media screen and (max-width: 1200px) {
          .video-detail {
            font-size: 12px;
          }
        }
      }

      .video {
        margin-right: 2vw;
      }

      .video:nth-of-type(5) {
        margin-right: 0;
      }

      .empty {
        height: 150px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          height: 100px;
        }

        span {
          display: inline-block;
          margin: 10px;
          font-size: 0.8rem;
          color: #909399;
        }
      }
    }

    .delivery-class-list {
      width: 100%;
      height: 14.6vw;
      min-height: 210px;
      margin-top: 40px;
      display: flex;
      flex-wrap: no-wrap;
      justify-content: flex-start;
      overflow-x: auto;

      .video {
        width: 14.4vw;
        height: 100%;
        min-width: 192px;
        display: inline-block;
        border-radius: 3px;
        overflow: hidden;

        .click-box {
          cursor: pointer;

          .video-img {
            position: relative;
            overflow: hidden;
            transition: opacity 0.3s;
            -moz-transition: opacity 0.3s;
            -webkit-transition: opacity 0.3s;
            -o-transition: opacity 0.3s;

            .poster {
              height: 100%;
              width: 100%;
              transition: all 0.6s;
            }

            .video-tag {
              font-size: 14px;
            }

            .video-play-bg {
              position: absolute;
              height: 100%;
              width: 100%;
              top: 0;
              left: 0;
              background-color: rgba(0, 0, 0, 0.3);
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.3s;
              opacity: 0;
              visibility: hidden;
            }
          }
        }

        .click-box:hover {
          .video-img .poster {
            transform: scale(1.1);
          }

          /deep/ .video-img .video-play-bg {
            visibility: visible !important;
            opacity: 1 !important;
          }
        }

        a {
          text-decoration: none;
          color: black;
        }

        .video-img {
          width: 100%;
          height: 8.1vw;
          min-height: 108px;

          span {
            color: white;
            position: absolute;
            right: 0;
            padding: 0.2rem 0.5rem;
            border-radius: 0 3px;
          }

          .video-tag {
            font-size: 14px;
          }

          .viewer {
            width: 100%;
            height: 20%;
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            text-align: left;
            display: flex;
            font-size: 14px;
            align-items: center;
            color: white;
            padding-left: 0.5rem;
            box-sizing: border-box;
          }
        }

        .video-name {
          width: 100%;
          height: 2.5vw;
          min-height: 30px;
          white-space: nowrap;
          padding-left: 2px;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-weight: 500;
          text-align: left;
          display: flex;
          align-items: center;
        }

        .video-detail {
          height: 4vw;
          min-height: 40px;
          font-size: 14px;
          color: #909399;
          position: relative;

          div {
            text-align: left;
            height: 2vw;
            min-height: 20px;
          }

          div:nth-of-type(2) {
            font-size: 12px;
          }
        }

        @media screen and (max-width: 1200px) {
          .video-detail {
            font-size: 12px;
          }
        }
      }

      .video {
        margin-right: 2vw;
      }

      .video:nth-of-type(5) {
        margin-right: 0;
      }

      .empty {
        height: 150px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          height: 100px;
        }

        span {
          display: inline-block;
          margin: 10px;
          font-size: 0.8rem;
          color: #909399;
        }
      }
    }

    .quality-list {
      width: 100%;
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .quality-box {
        width: calc(50% - 10px);
        height: 12vw;
        background: #F2F6F8;
        border-radius: 5px;
        display: flex;
        margin-bottom: 20px;
        cursor: pointer;

        .left-box {
          width: 50%;
          height: 100%;
          background: url('~@/common/img/quality.png');
          background-size: 100% 100%;
        }

        .right-box {
          width: 50%;
          height: 100%;
          padding: 5% 3%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-around;

          .text-1 {
            font-size: 16px;
            font-weight: bold;
          }

          .text-2 {
            color: #292C32;
            font-size: 14px;
            text-align: justify;
            line-height: 1.5em;
          }
        }
      }
    }
  }
}

.top2 {
  width: 100%;
  margin: 6.5vh 0;

  .famous-teacher {
    width: 100%;
    min-width: 150px;

    .teacher-box {
      width: 80%;
      margin: auto;

      .teacher-list {
        width: 100%;
        // height: 13.8vw;
        margin-top: 40px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;

        .teacher {
          display: inline-block;
          overflow: hidden;
          padding: 0 15px;
          margin: 0 20px 40px 0;

          .click-box {
            cursor: pointer;

            .video-img {
              height: 60px;
              border-radius: 3px;
              overflow: hidden;
              transition: opacity 0.3s;
              -moz-transition: opacity 0.3s;
              -webkit-transition: opacity 0.3s;
              -o-transition: opacity 0.3s;

              .poster {
                height: 100%;
                width: 100%;
                transition: all 0.3s;
              }

              .video-tag {
                font-size: 14px;
              }

              .video-play-bg {
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.3);
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s;
                opacity: 0;
                visibility: hidden;
              }
            }
          }

          .click-box:hover {
            .video-img .poster {
              transform: scale(1.1);
            }

            /deep/ .video-img .video-play-bg {
              visibility: visible !important;
              opacity: 1 !important;
            }
          }

          a {
            text-decoration: none;
            color: black;
          }

          .video-img {
            width: 100%;
            height: 100%;
          }

          .teacher-name {
            width: 100%;
            min-height: 24px;
            white-space: nowrap;
            padding: 10px 5px 15px;
            box-sizing: border-box;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
          }

          @media screen and (max-width: 1080px) {
            .teacher-name {
              font-size: 14px;
            }
          }
        }

        .teacher {
          margin-right: 2vw;
        }

        .teacher:nth-of-type(5) {
          margin-right: 0;
        }

        .empty {
          height: 150px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            height: 100px;
          }

          span {
            display: inline-block;
            margin: 10px;
            font-size: 0.8rem;
            color: #909399;
          }
        }
      }

      @media screen and (max-width: 1075px) {
        .live-list {
          min-height: 201px;
          padding-bottom: 10px;
          overflow-x: auto;
        }
      }
    }
  }
}

.top3 {
  width: 100%;
  margin: 6.5vh 0;

  .famous-teacher {
    width: 100%;
    min-width: 150px;

    .teacher-box {
      width: 80%;
      margin: auto;

      .teacher-list {
        width: 100%;
        // height: 13.8vw;
        margin-top: 40px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;

        .teacher {
          width: 7vw;
          min-width: 90px;
          display: inline-block;
          overflow: hidden;

          .click-box {
            cursor: pointer;

            .video-img {
              height: 7vw;
              min-height: 90px;
              border-radius: 3px;
              overflow: hidden;
              transition: opacity 0.3s;
              -moz-transition: opacity 0.3s;
              -webkit-transition: opacity 0.3s;
              -o-transition: opacity 0.3s;

              .poster {
                height: 100%;
                width: 100%;
                transition: all 0.3s;
              }

              .video-tag {
                font-size: 14px;
              }

              .video-play-bg {
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.3);
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s;
                opacity: 0;
                visibility: hidden;
              }
            }
          }

          .click-box:hover {
            .video-img .poster {
              transform: scale(1.1);
            }

            /deep/ .video-img .video-play-bg {
              visibility: visible !important;
              opacity: 1 !important;
            }
          }

          a {
            text-decoration: none;
            color: black;
          }

          .video-img {
            width: 100%;
            height: 100%;
          }

          .teacher-name {
            width: 100%;
            min-height: 24px;
            white-space: nowrap;
            padding: 10px 5px 15px;
            box-sizing: border-box;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
          }

          @media screen and (max-width: 1080px) {
            .teacher-name {
              font-size: 14px;
            }
          }
        }

        .teacher {
          margin-right: 2vw;
        }

        .teacher:nth-of-type(5) {
          margin-right: 0;
        }

        .empty {
          height: 150px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            height: 100px;
          }

          span {
            display: inline-block;
            margin: 10px;
            font-size: 0.8rem;
            color: #909399;
          }
        }
      }

      @media screen and (max-width: 1075px) {
        .live-list {
          min-height: 201px;
          padding-bottom: 10px;
          overflow-x: auto;
        }
      }
    }
  }
}

.middle {
  height: 30vw;
  min-height: 345px;
  width: 100%;
  background: url('~@/common/img/banner2.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;

  .ranking-list {
    width: 30%;
    height: 100%;
    padding-top: 3vh;
    margin-right: 10%;
    box-sizing: border-box;

    /deep/ .el-table {
      // color: #f2f2f2;
      .el-table__body tr:hover>td {
        background: transparent !important;
        // color #ececec
        font-size: 20px !important;
      }

      .el-table__empty-text {
        // color #ececec
      }

      td {
        transition: all 0.1s linear;
        font-size: 16px;
        padding: 0.3vw 0px;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .notice {
      display: none;
    }

    .ranking-list {
      width: 70%;
    }
  }

  .notice {
    width: 40%;
    height: 100%;
    padding-top: 3vh;
    box-sizing: border-box;
  }
}

.bottom {
  height: calc(28vw + 82px);
  width: 100%;
  min-height: 362px;
  display: flex;
  justify-content: center;
  margin: 6.5vh 0;

  .resource-box {
    height: 100%;
    width: 80%;

    .empty {
      height: 150px;
      width: 100%;
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        height: 100px;
      }

      span {
        display: inline-block;
        margin: 10px;
        font-size: 0.8rem;
        color: #909399;
      }
    }

    .title {
      margin-bottom: 40px;
    }

    .out-box {
      width: 100%;
      overflow-x: auto;
    }

    .left-box {
      width: 40%;
      height: 28vw;
      min-width: 320px;
      min-height: 280px;
      display: inline-block;

      .first-resource {
        width: 100%;
        height: 100%;
        border-radius: 3px;
        overflow: hidden;

        .click-box {
          height: 100%;
          background-color: #f8f8f8;
        }

        a {
          text-decoration: none;
          color: black;
        }

        .video-img {
          width: 100%;
          height: 18vw;
          min-height: 180px;
        }

        .video-name {
          width: 100%;
          height: 4vw;
          line-height: 4vw;
          min-height: 40px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 24px;
          font-weight: 500;
          text-align: left;
          padding-left: 0.5rem;
          box-sizing: border-box;
        }

        .video-detail {
          width: 100%;
          height: 6vw;
          min-height: 60px;
          font-size: 16px;
          color: #999999;
          text-align: left;
          padding-left: 0.5rem;
          box-sizing: border-box;

          .video-detail-owner {
            height: 3vw;
            min-height: 30px;
          }

          .btn-box {
            height: 3vw;
            min-height: 30px;
            text-align: left;

            .el-link--default {
              cursor: text;
              color: #999999;
            }
          }
        }

        @media screen and (max-width: 1000px) {
          .video-name {
            line-height: 40px;
            font-size: 18px;
          }

          .video-detail {
            font-size: 14px;

            .btn-box {
              .el-link--default {
                font-size: 12px !important;
              }
            }
          }
        }
      }
    }

    .right-box {
      width: 60%;
      height: 28vw;
      min-width: 480px;
      min-height: 280px;
      display: inline-block;

      .other-resource {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;

        .video {
          width: 14.29vw;
          height: 13.2vw;
          min-width: 144px;
          min-height: 132px;
          border-radius: 3px;
          overflow: hidden;

          a {
            text-decoration: none;
            color: black;
          }

          .video-img {
            width: 100%;
            height: 8.1vw;
            min-height: 81px;

            .button-box {
              width: 100%;
              height: 20px;
              position: absolute;
              bottom: 0;
              text-align: left;
              padding-left: 10px;
              box-sizing: border-box;

              .el-link--default {
                font-size: 14px;
                color: white;
              }
            }
          }

          .video-name {
            width: 100%;
            height: 3.1vw;
            line-height: 3.1vw;
            min-height: 31px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            text-align: left;
            padding-left: 0.5rem;
            box-sizing: border-box;
          }

          .video-detail {
            width: 100%;
            height: 2vw;
            min-height: 20px;
            color: #999999;
            padding-left: 0.5rem;
            position: relative;
            box-sizing: border-box;

            .video-detail-owner {
              font-size: 14px;
              text-align: left;
            }
          }

          @media screen and (max-width: 1000px) {
            .video-name {
              font-size: 14px;
              line-height: 31px;
            }

            .video-detail {
              .video-detail-owner {
                font-size: 12px;
              }
            }

            .video-img {
              .el-link--default {
                font-size: 12px !important;
              }
            }
          }
        }

        .video:nth-of-type(1) {
          margin-left: 1.6vw;
          margin-bottom: 1.6vw;
        }

        .video:nth-of-type(2) {
          margin-left: 1.6vw;
          margin-bottom: 1.6vw;
        }

        .video:nth-of-type(3) {
          margin-left: 1.6vw;
          margin-bottom: 1.6vw;
        }

        .video:nth-of-type(4) {
          margin-left: 1.6vw;
        }

        .video:nth-of-type(5) {
          margin-left: 1.6vw;
        }

        .video:nth-of-type(6) {
          margin-left: 1.6vw;
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .middle {
    background-size: auto 100%;
  }
}

@media screen and (max-width: 1000px) {
  .bottom {
    min-height: 372px;

    .out-box {
      padding-bottom: 10px;
    }
  }
}

.link-poster {
  height: 100%;
  transition: all 0.5s ease;
}

.click-box:hover {
  .video-img .link-poster {
    transform: scale(1.1);
  }
}
</style>
